import {
  isAutomatedMonitorsTest,
  isCloudTest,
  isContentTest,
} from '../../utils/common';
import OverflowTooltip from '../OverflowTooltip';

const testSubTypeRenderer = (value: string) => (
  <OverflowTooltip>
    {isAutomatedMonitorsTest(value)
      ? 'automated'
      : isContentTest(value)
      ? 'metric_anomalies'
      : isCloudTest(value)
      ? 'cloud'
      : value}
  </OverflowTooltip>
);

export default testSubTypeRenderer;
